<template>
  <div>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-file-clock</v-icon>
          ADMINISTRAR DAES
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="busqueda"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          class="mt-5"
        >
        </v-text-field>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="abrirFormDae()">
          <v-icon>mdi-plus-circle-outline</v-icon> Nueva DAE
        </v-btn>
      </v-toolbar>
      <ListaDaesFincaComponent
        fincaId=""
        @abrirFormDae="abrirFormDae"
        @cargarLista="cargarLista"
        @handlePageChange="handlePageChange"
        :lista="lista"
        :pageCount="pageCount"
        :busqueda="busqueda"
        :tipoEmpresa="tipoEmpresa"
        :currentPage.sync="currentPage"
        :itemsPerPage="itemsPerPage"
      >
      </ListaDaesFincaComponent>
      <!-- <v-data-table :headers="_headers" :items="lista" 
					:items-per-page=itemsPerPage 
					:search=busqueda					
					:options.sync="options"
					
					hide-default-footer
				:loading=loadingTable class="elevation-1"
				>
				<template v-slot:item.opcion="{item}">
					<v-btn icon color='red' target="_blank" @click="abrirFormDae(item.FUE_ID)">
						<v-icon color='#ff9800'>mdi-table-edit</v-icon>
					</v-btn>
				</template>

				<template v-slot:item.description="{item}">
					<v-btn icon color='red' target="_blank" @click="abrirFormDae(item.FUE_ID)">
						<v-icon color='#119800'>mdi-square-edit-outline</v-icon>
					</v-btn>
					{{item.FUE}}
				</template>

				<template v-slot:footer>
                <v-pagination
                    class='mt-10'
                    v-model="currentPage"
                    :length="pageCount"
                    @input="handlePageChange"                    
                    total-visible=10     
                ></v-pagination>
            </template>
			</v-data-table>  -->
    </v-card>

    <!-- DIALOG DAE -->
    <v-dialog v-model="dialogDae" persistent max-width="550px">
      <v-card>
        <v-card-title>
          <v-icon class="mx-1">mdi-file-clock</v-icon>
          <span class="headline">{{ formDaeTitulo }} </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formDae">
              <v-row v-if="1 == 2">
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field v-model="datosDae.daeId" label="Codigo">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pb-0" cols="4">
                  <v-select
                    small
                    v-model="datosDae.daeNumAduana"
                    :rules="requiredRule"
                    :items="[
                      { codigo: '055', desc: '[055] Quito' },
                      { codigo: '028', desc: '[028] Guayaquil Marítimo' },
                    ]"
                    item-text="desc"
                    item-value="codigo"
                    label="Ofic. Aduana"
                  >
                  </v-select>
                </v-col>
                <v-col class="pt-0 pb-0" cols="3">
                  <v-text-field
                    class="md-12"
                    small
                    v-model="datosDae.daeNumAnio"
                    label="Año"
                    :rules="requiredRule"
                  ></v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="2">
                  <v-text-field
                    readonly
                    class="md-12"
                    maxlength="8"
                    small
                    v-model="datosDae.daeNumRegimen"
                    label="Regimen"
                    :rules="requiredRule"
                  ></v-text-field>
                </v-col>

                <v-col class="pt-0 pb-0" cols="3">
                  <v-text-field
                    class="md-12"
                    maxlength="8"
                    small
                    v-model="datosDae.daeNumSec"
                    label="Secuencia"
                    :rules="daeSecRule"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    disabled
                    label="Número de DAE"
                    v-model="numDae"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-select
                    small
                    :items="getAnios"
                    item-text="anio"
                    item-value="num_anio"
                    label="Año"
                    :rules="requiredRule"
                    v-model="datosDae.anio"
                  />
                </v-col>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-select
                    :rules="_reglasMes"
                    :items="months"
                    item-text="name"
                    item-value="number"
                    small
                    v-model="datosDae.mes"
                    label="Mes"
                  />
                </v-col>
              </v-row>

              <!--							<v-row>
								<v-col class="pt-0 pb-0" cols="12">
									<v-text-field type="date" :rules="requiredRule" small v-model="datosDae.desde" label="Desde" />

								</v-col>
							</v-row>

							<v-row>
								<v-col class="pt-0 pb-0" cols="12">
									<v-text-field type="date" :rules="requiredRule" small v-model="datosDae.hasta" label="Hasta" />

								</v-col>
							</v-row>
							-->

              <v-row>
                <v-col class="pt-0 pb-0" cols="12">
                  <v-autocomplete
                    :rules="requiredRule"
                    v-model="datosDae.codigoPais"
                    small
                    item-text="NOMCOD"
                    item-value="PAIS_CODIGO"
                    :items="paises"
                    label="País de destino"
                    cache-items
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field
                    small
                    v-model="descripcionDae"
                    label="Descripcion destino"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-center">
            <v-btn small color="primary" @click="guardarDae">
              <v-icon>mdi-content-save</v-icon> Guardar
            </v-btn>
            &nbsp;
            <v-btn small @click="dialogDae = !dialogDae">
              <v-icon>mdi-cancel</v-icon> Cancelar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";
import moment from "moment";
import ListaDaesFincaComponent from "./ListaDaesFincaComponent.vue";

export default {
  name: "AdministrarDaesFincaComponent",
  components: {
    ListaDaesFincaComponent,
  },
  data: () => ({
    headers: [
      { text: "Opciones", value: "opcion" },
      { text: "Finca", value: "FINCA_NOMBRE" },
      { text: "Codigo", value: "FUE_ID" },
      { text: "Nombre", value: "FUE" },
      { text: "Destino", value: "DAE_DEST" },
      { text: "Válido hasta", value: "FECHA_CADUCA" },
    ],

    requiredRule: [(v) => !!v || "El campo es requerido"],
    daeSecRule: [(v) => v.length == 8 || "El número de tener 8 digitos"],
    daeAnioRule: [(v) => v.length == 8 || "El número de tener 8 digitos"],
    daeMesRule: [
      (v) =>
        v >= new Date().getMonth() + 1 ||
        "El mes debe ser mayor o igual al actual",
    ],

    lista: [],
    paises: [],
    options: {},

    notifications: false,

    daeEdit: false,
    busqueda: null,
    formDaeTitulo: "",

    dialogDae: false,
    datosDae: {
      daeId: "",
      daeDestino: "",
      anio: "",
      mes: "",
      desde: "",
      hasta: "",
      fincaId: "",
      daeNumAduana: "",
      daeNumAnio: "",
      daeNumRegimen: "40",
      daeNumSec: "",
      daeNum: "",
      codigoPais: "",
    },

    itemsPerPage: 20,
    pageCount: 1,
    totalItems: 0,
    currentPage: 1,
    tipoEmpresa: "1",
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user", "months"]),

    ...mapGetters("access", []),

    numDae() {
      return (
        this.datosDae.daeNumAduana +
        "-" +
        this.datosDae.daeNumAnio +
        "-" +
        this.datosDae.daeNumRegimen +
        "-" +
        this.datosDae.daeNumSec
      );
    },
    descripcionDae() {
      moment.locale("es");

      let m = moment(
        this.datosDae.anio + "-" + this.datosDae.mes + "-01"
      ).format("MMM");
      this.datosDae.daeDestino = (
        this.datosDae.codigoPais +
        " " +
        m
      ).toUpperCase();
      return (this.datosDae.codigoPais + " " + m).toUpperCase();
    },
    _headers() {
      let head2 = [];
      for (let i = 0; i < this.headers.length; i++) {
        if (this.tipoEmpresa == "1") {
          if (!["FUE_ID", "FINCA_NOMBRE"].includes(this.headers[i].value)) {
            head2.push(this.headers[i]);
          }
        } else {
          head2.push(this.headers[i]);
        }
      }

      return head2;
    },
    _reglasMes() {
      if (this.datosDae.anio == new Date().getFullYear().toString()) {
        if (this.datosDae.mes < new Date().getMonth() + 1) {
          return [false || "El mes debe ser mayor o igual"];
        }

        if (this.datosDae.mes > new Date().getMonth() + 2) {
          return [false || "El mes debe ser igual al actual"];
        }
      }
    },
    getAnios() {
      let anio = new Date().getFullYear();
      let mes = new Date().getMonth();

      let items = [{ num_anio: anio, anio: anio }];
      let anioSig = { num_anio: anio + 1, anio: anio + 1 };
      if (mes == 11) items.push(anioSig);

      return items;
    },
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setLoadingTable",
      "setTitleToolbar",
    ]),

    ...mapActions("master", ["requestApi", "alertNotification"]),

    guardarDae() {
      if (!this.$refs.formDae.validate()) {
        return;
      }
      if (this.daeEdit == false) {
        this.setUrl("api/dae");
        this.requestApi({
          method: "POST",
          data: {
            dae_num: this.numDae,
            fecha_caduca: this.datosDae.hasta,
            fecha_inicio: this.datosDae.desde,
            ente_id: this.datosDae.fincaId,
            finca_id: this.datosDae.fincaId,
            destino: this.datosDae.daeDestino,
            cod_pais: this.datosDae.codigoPais,
            mes: this.datosDae.mes,
            anio: this.datosDae.anio,
          },
        })
          .then((res) => {
            //console.log(res);
            this.cargarLista();
            this.dialogDae = false;
          })
          .catch((error) => {
            //this.dialogDae = false;
          })
          .finally(() => {
            //this.dialogDae = false;
          });
      }
      if (this.daeEdit == true) {
        this.setUrl("api/dae/" + this.datosDae.daeId);
        this.requestApi({
          method: "PUT",
          data: {
            dae_id: this.datosDae.daeId,
            dae_num: this.numDae,
            fecha_caduca: this.datosDae.hasta,
            fecha_inicio: this.datosDae.desde,
            ente_id: this.datosDae.fincaId,
            finca_id: this.datosDae.fincaId,
            destino: this.datosDae.daeDestino,
            cod_pais: this.datosDae.codigoPais,
            anio: this.datosDae.anio,
            mes: this.datosDae.mes,
          },
        })
          .then((res) => {
            console.log(res);
            this.cargarLista();
          })
          .catch(() => {})
          .then(() => {
            this.dialogDae = false;
          });
      }
    },

    cargarLista() {
      this.setLoadingTable(true);
      this.setUrl("api/lista-daes-finca");
      this.requestApi({
        method: "GET",
        data: {
          pageCount: this.pageCount,
          itemsPerPage: this.itemsPerPage,
          page: this.currentPage,
        },
      })
        .then((res) => {
          //console.log(res);
          this.lista = res.data.lista;
          this.paises = res.data.paises;
          this.pageCount = res.data.pageCount;
          this.totalItems = res.data.totalItems;
          this.tipoEmpresa = res.data.tipoEmpresa.toString();
          //console.log(this.totalItems)
        })
        .catch(() => {})
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    abrirFormDae(daeid = null) {
      this.datosDae.daeId = "";
      this.datosDae.daeNum = "";
      this.datosDae.daeDestino = "";
      this.datosDae.codigoPais = "";
      this.datosDae.desde = "";
      this.datosDae.hasta = "";
      this.datosDae.fincaId = "";
      this.datosDae.daeNumAduana = "";
      this.datosDae.daeNumAnio = new Date().getFullYear().toString();
      this.datosDae.daeNumRegimen = "40";
      this.datosDae.daeNumSec = "";
      (this.datosDae.anio = new Date().getFullYear().toString()),
        (this.datosDae.mes = ("0" + (new Date().getMonth() + 1)).slice(-2)),
        (this.dialogDae = true);
      this.daeEdit = false;

      this.formDaeTitulo = "Nueva DAE";

      if (daeid) {
        this.daeEdit = true;
        this.formDaeTitulo = "Editar DAE";
        this.setUrl("api/dae/" + daeid);
        this.requestApi({
          method: "GET",
          data: {},
        })
          .then((res) => {
            //console.log(res.data.dae)
            this.datosDae.daeId = daeid;
            this.datosDae.daeNumAduana = res.data.dae.FUE.split("-")[0];
            this.datosDae.daeNumAnio = res.data.dae.FUE.split("-")[1];
            this.datosDae.daeNumRegimen = res.data.dae.FUE.split("-")[2];
            this.datosDae.daeNumSec = res.data.dae.FUE.split("-")[3];

            this.datosDae.daeNum = res.data.dae.FUE;
            this.datosDae.desde = res.data.dae.FECHA_INICIO;
            this.datosDae.hasta = res.data.dae.FECHA_CADUCA;
            this.datosDae.daeDestino = res.data.dae.DESTINO;
            this.datosDae.codigoPais = res.data.dae.COD_PAIS;
            this.datosDae.fincaId = res.data.dae.FINCA_ID;
            this.formDae = true;
          })
          .then(() => {});
      }
    },

    eliminarDae(permissionId) {
      Vue.swal({
        html: "Está seguro de eliminar el permiso?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cerrar",
        ...this.paramAlertQuestion,
      }).then((result) => {
        if (result.isConfirmed) {
          this.setUrl("user-security-group");
          this.requestApi({
            method: "DELETE",
            data: {
              securityGroupPermissionId: this.securityGroupId,
              permissionId: permissionId,
              typeDelete: "eliminarPermiso",
            },
          }).then((res) => {
            this.alertNotification({ param: { html: res.data.detail } });
            let obj = this.permisos.find(
              (e) => e.permission_id == permissionId
            );
            let index = this.permisos.indexOf(obj);
            this.permisos.splice(index, 1);
          });
        }
      });
    },

    handlePageChange() {
      this.cargarLista();
    },
  },
  mounted() {
    //this.$vuetify.lang.current = 'es'
    //this.cargarLista()
    document.title = "Sistema de carga";
    this.setTitleToolbar("DAES");
    this.cargarLista();
  },
  watch: {
    options: {
      handler() {
        this.cargarLista();
      },
      deep: true,
    },
  },
};
</script>
